module.exports = __webpack_public_path__ + "dab4316ec405fc7a623aa7fc501c5040.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-1.png
// module id = 1759
// module chunks = 0